/*
 * StammdatenManagement.tsx
 * Author: -
 * Date: -
 *
 * Copyright: DMT GmbH & Co. KG
 */
import '../style/Stammdaten.scss';

import React, {useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';
import {checkPermission} from '../functions/functionLibrary';
import {permissions} from '../config/permissions';
import ViewButtons from '../components/global/ViewButtons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faBook,
    faComments,
    faFileContract,
    faMoneyBill,
    faFileInvoiceDollar,
    faMap,
    faPerson,
    faProjectDiagram,
    faSection,
    faLeaf,
    faMagnifyingGlass
} from '@fortawesome/free-solid-svg-icons';
import {
    buttonCSVImport,
    buttonCSVImportData,
    makeButtonItem,
    buttonShowMap,
} from '../components/global/viewButtonSelection';
import CustomDialog, {CustomDialogHeaderType} from '../components/global/CustomDialog';
import LayoutMainContentTabMenu from '../components/global/LayoutMainContentTabMenu';
import {ImportCsvAlkis} from '../components/projectMasterData/imports/ImportCsvAlkis';
import {PersonOverview} from '../components/globalData/person/PersonOverview';
import {ParcelOverview} from '../components/globalData/parcel/ParcelOverview';
import {
    useCheckImportPersonsQuery, useDeleteImportDataMutation,
    useTransferImportDataQuery
} from '../redux/rtk/injectedPersonApi';
import {useAppSelector} from '../redux/hooks';
import {CustomConfirmDialog} from '../components/global/CustomConfirmDialog';
import {showMessageOnError, showMessageOnSuccess} from '../components/global/CustomToast';
import {Nullable, onClickShowMap} from '../components/functions/Global';
import {LandRegisterOverview} from '../components/globalData/landRegister/LandRegisterOverview';
import {LandRegisterDialogEditForm} from '../components/globalData/landRegister/LandRegisterDialogEditForm';
import {useDeleteLandRegisterMutation} from '../redux/rtk/injectedLandregisterApi';
import {Button} from 'primereact/button';
import {classNames} from 'primereact/utils';
import {Splitter, SplitterPanel} from 'primereact/splitter';
import GeoData from './GeoData';
import {useSetStatusMutation} from '../redux/rtk/injectedMappingApi';
import {setGeoData} from '../functions/functionsOpenlayer';
import {ProcessOverview} from '../components/globalData/process/ProcessOverview';
import UnderConstruction from './pages/UnderConstruction';
import {LandRegister, Parcel, Person} from '../components/functions/GlobalData';

type Props = {
    project: any
}

const GlobalData = (props: Props): JSX.Element => {
    const showMapTempLS: Nullable<string> = localStorage.getItem('showMap');
    const showMapTemp: boolean = (showMapTempLS === 'true' && props.project != null);

    const {t} = useTranslation(['common', 'globalData']);
    const status = useAppSelector((state: any) => state.importData);
    const projectId = props.project ? props.project.id : '';

    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [showCSVImportDialog, setShowCSVImportDialog] = useState<boolean>(false);
    const [showCSVImportData, setShowCSVImportData] = useState<boolean>(false);
    const [mayEditUM, setMayEditUM] = useState<boolean>(false);
    const [viewButtonsRerender, setViewButtonsRerender] = useState<boolean>(true);
    const [menuItems, setMenuItems] = useState<any[]>([]);

    const [selectedParcels, setSelectedParcels] = useState<Parcel[]>([]);
    const [selectedPersons, setSelectedPersons] = useState<Person[]>([]);
    const [selectedLandRegisters, setSelectedLandRegisters] = useState<LandRegister[]>([]);

    const [skipImport, setSkipImport] = useState<boolean>(true);

    const [setStatus, resultSetStatus] = useSetStatusMutation();
    const [deleteLandRegister, resultDeleteLandRegister] = useDeleteLandRegisterMutation();
    const [deleteImportData, resultDeleteImportData] = useDeleteImportDataMutation();

    const [user, setUser] = useState<any>(undefined);

    const [showMap, setShowMap] = useState<boolean>(showMapTemp);
    const [activeIndex, setActiveIndex] = useState<number>(props.project ? 0 : 1);

    const formName = 'importCSVForm';

    useEffect(() => {
        const userString = localStorage.getItem('user');

        if (userString) {
            setUser(JSON.parse(userString)[0]);
        }
    }, []);

    useEffect(() => {
        setShowMap(showMapTemp);
    }, [showMapTemp]);

    const person = useCheckImportPersonsQuery({projectId: projectId});
    const importData = useTransferImportDataQuery({projectId: projectId}, {skip: skipImport});

    const geoDataProject = setGeoData(props);

    useEffect(() => {
        if (user) {
            if (checkPermission(permissions.editUM)) {
                setMayEditUM(true);
            }
            if (checkPermission(permissions.isAdmin)) {
                setIsAdmin(true);
            }
            console.log('user', user);
        }
    }, [user]);

    useEffect(() => {
        person.refetch();
    }, [status.uploadTotal]);

    useEffect(() => {
        console.log(importData);
        if (importData.data) {
            if (importData.data.Status === 'OK') {
                showMessageOnSuccess(t('globalData:global.getCSVDialog.headerImportedData'), t('globalData:toasts.importComplete'));
                hideDialog();
                person.refetch();
            } else {
                showMessageOnError(t('globalData:toasts.importError'), JSON.stringify(importData.data));
            }
        }
    }, [importData.data]);

    useEffect(() => {
        const items = [];

        // if (Array.isArray(person.data)) {
        //     items.push(makeButtonItem(buttonCSVImport, t, () => {
        //         setShowCSVImportDialog(true);
        //     }, true, false));
        // } else {
        //     items.push(makeButtonItem(buttonCSVImportData, t, () => {
        //         setShowCSVImportData(true);
        //     }, true, false));
        // }

        if (props.project) {
            items.push(makeButtonItem(buttonShowMap, t, () => {
                onClickShowMap(setShowMap);
            }, true, false));
        }

        const itemsProcess = [];
        itemsProcess.push(...items);

        const itemsParcel = [];
        itemsParcel.push(...items);

        const itemsPerson = [];
        itemsPerson.push(...items);

        const itemsLandRegister = [];

        itemsLandRegister.push(...items);

        const itemsCorrespondence: any[] = [];
        const itemsContract: any[] = [];
        const itemsPayment: any[] = [];
        const itemsInvoice: any[] = [];

        const tempMenuItems = [];

        tempMenuItems.push({
            id: 'process',
            label: t('globalData:process.plural'),
            icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faProjectDiagram}/>,
            component: <ProcessOverview projectId={projectId}
                                        editable={true} // TODO: check permission
                                        expandable={true}
                                        hideGlobalFilter={false}
                                        showParcels={true}
                                        showPersons={true}
                                        showLandRegisters={true}
                                        showColumnFilters={true}
                                        selectable={true}
                                        multiSelection={true}
                                        onSelection={onSelectionPerson}
                                        geoData={geoDataProject}
            />,
            buttons: <ViewButtons title={t('')} items={itemsProcess} rerender={viewButtonsRerender}
                                  preventShrink={true}/>,
            buttonsTop: true,
            showMap: true,
            disabled: props.project == null,
            visible: checkPermission(permissions.isAdmin) || checkPermission(permissions.seeProcess) || checkPermission(permissions.editProcess)
        });


        tempMenuItems.push({
            id: 'persons',
            label: t('globalData:global.personen'),
            icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faPerson}/>,
            component: <PersonOverview projectId={projectId}
                                       editable={( projectId ) ? checkPermission(permissions.editPersons) : checkPermission(permissions.editMasterData)}
                                       expandable={true}
                                       hideGlobalFilter={false} commonData={true} showParcels={true}
                                       showPersons={true}
                                       showLandRegisters={true}
                                       showShareInfos={false}
                                       showSuggestions={false}
                                       showColumnFilters={true}
                                       selectable={true}
                                       multiSelection={true}
                                       onSelection={onSelectionPerson}
                                       geoData={geoDataProject}
            />,
            buttons: <ViewButtons title={t('')} items={itemsPerson} rerender={viewButtonsRerender}
                                  preventShrink={true}
            />,
            buttonsTop: true,
            showMap: true,
            visible: checkPermission(permissions.isAdmin) || checkPermission(permissions.seePersons) || checkPermission(permissions.editPersons)
        });

        tempMenuItems.push({
            id: 'parcels',
            label: t('globalData:global.flurstuecke'),
            icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faMap}/>,
            component: <ParcelOverview projectId={projectId}
                                       editable={checkPermission(permissions.editParcels)} expandable={true}
                                       hideGlobalFilter={false} commonData={true}
                                       showPersons={true}
                                       showLandRegisters={true}
                                       showUtilisationInfo={false}
                                       showShareInfos={false}
                                       showColumnFilters={true}
                                       selectable={true}
                                       multiSelection={true}
                                       onSelection={onSelectionParcel}
                                       geoData={geoDataProject}
            />,
            buttons: <ViewButtons title={t('')} items={itemsParcel} rerender={viewButtonsRerender}
                                  preventShrink={true}/>,
            buttonsTop: true,
            showMap: true,
            visible: checkPermission(permissions.isAdmin) || checkPermission(permissions.seeParcels) || checkPermission(permissions.editParcels)
        });

        tempMenuItems.push({
            id: 'landregisters',
            label: t('globalData:global.landRegisters'),
            icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faBook}/>,
            component: <LandRegisterOverview
                editable={true}
                showParcels={true}
                showPersons={true}
                showShareInfos={false}
                projectId={projectId}
                expandable={true}
                hideGlobalFilter={false} commonData={true}
                showColumnFilters={true}
                selectable={true}
                multiSelection={true}
                onSelection={onSelectionLandRegister}
                geoData={geoDataProject}
            />,
            buttons: <ViewButtons title={t('')} items={itemsLandRegister} rerender={viewButtonsRerender}
                                  preventShrink={true}/>,
            buttonsTop: true,
            showMap: true,
            visible: checkPermission(permissions.isAdmin) || checkPermission(permissions.seeLandregister) || checkPermission(permissions.editLandregister)
        });

        tempMenuItems.push({
            id: 'ecoaccounts',
            label: t('globalData:global.ecoAccounts'),
            icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faLeaf}/>,
            component: <UnderConstruction/>,
            buttons: <ViewButtons title={t('')} items={[]} rerender={viewButtonsRerender}
                                  preventShrink={true}/>,
            buttonsTop: true,
            showMap: false,
            disabled: true
        });

        tempMenuItems.push({
            id: 'research',
            label: t('globalData:global.research'),
            icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faMagnifyingGlass}/>,
            component: <UnderConstruction/>,
            buttons: <ViewButtons title={t('')} items={[]} rerender={viewButtonsRerender}
                                  preventShrink={true}/>,
            buttonsTop: true,
            showMap: false,
            disabled: true
        });

        tempMenuItems.push({
            id: 'correspondence',
            label: t('correspondence:plural'),
            icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faComments}/>,
            component: <UnderConstruction/>,
            buttons: <ViewButtons title={t('')} items={itemsCorrespondence} rerender={viewButtonsRerender}
                                  preventShrink={true}/>,
            buttonsTop: true,
            showMap: false,
            // disabled: props.project == null,
            disabled: true
        });

        tempMenuItems.push({
            id: 'contract',
            label: t('contract:pluralShort'),
            icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faFileContract}/>,
            component: <UnderConstruction/>,
            buttons: <ViewButtons title={t('')} items={itemsContract} rerender={viewButtonsRerender}
                                  preventShrink={true}/>,
            buttonsTop: true,
            showMap: false,
            // disabled: props.project == null,
            disabled: true
        });

        tempMenuItems.push({
            id: 'legalProceedings',
            label: t('globalData:global.legalProceedings'),
            icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faSection}/>,
            component: <UnderConstruction/>,
            buttons: <ViewButtons title={t('')} items={[]} rerender={viewButtonsRerender}
                                  preventShrink={true}/>,
            buttonsTop: true,
            showMap: true,
            disabled: true
        });

        tempMenuItems.push({
            id: 'payment',
            label: t('payment:plural'),
            icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faMoneyBill}/>,
            component: <UnderConstruction/>,
            buttons: <ViewButtons title={t('')} items={itemsPayment} rerender={viewButtonsRerender}
                                  preventShrink={true}/>,
            buttonsTop: true,
            showMap: false,
            // disabled: props.project == null,
            disabled: true
        });

        tempMenuItems.push({
            id: 'invoice',
            label: t('invoice:plural'),
            icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faFileInvoiceDollar}/>,
            component: <UnderConstruction/>,
            buttons: <ViewButtons title={t('')} items={itemsInvoice} rerender={viewButtonsRerender}
                                  preventShrink={true}/>,
            buttonsTop: true,
            showMap: false,
            // disabled: props.project == null,
            disabled: true
        });

        setMenuItems(tempMenuItems);
    }, [person.data, selectedParcels, selectedPersons, selectedLandRegisters]);

    useEffect(() => {
        if (resultDeleteImportData.isSuccess) {
            showMessageOnSuccess(t('globalData:toasts.deleteImportComplete'), '');
        } else if (resultDeleteImportData.isError) {
            showMessageOnError(t('globalData:toasts.importError'), JSON.stringify(resultDeleteImportData.data));
        }
    }, [resultDeleteImportData]);

    const onSelectionParcel = (e: any) => {
        setSelectedParcels(e);
    };

    const onSelectionPerson = (e: any) => {
        setSelectedPersons(e);
    };

    const onSelectionLandRegister = (e: any) => {
        setSelectedLandRegisters(e);
    };

    const onClickSelectionActivateLandRegister = () => {
        onClickSetSelectionStatus(0, 'grundbuch');
    };

    const onClickSelectionDeactivateLandRegister = () => {
        onClickSetSelectionStatus(1, 'grundbuch');
    };

    const onClickSetSelectionStatus = (status_id: number, type: string) => {
        CustomConfirmDialog({
            message: t('globalData:dialogs.activateSelection'),
            header: t('confirmDialog:activateSelectionDialogHeader'),
            translation: t,
            onConfirm: () => {
                switch (type) {
                    case 'person':
                        for (let i = 0; i < selectedPersons.length; i++) {
                            const item = selectedPersons[i];
                            setStatus({
                                project_id: props.project ? props.project.id : '',
                                status: status_id,
                                status_type: type,
                                person_id: item.person_id
                            });
                        }
                        break;

                    case 'flurstueck':
                        for (let i = 0; i < selectedParcels.length; i++) {
                            const item = selectedParcels[i];
                            setStatus({
                                project_id: props.project ? props.project.id : '',
                                status: status_id,
                                status_type: type,
                                flurstueck_id: item.flurstueck_id
                            });
                        }
                        break;

                    case 'grundbuch':
                        for (let i = 0; i < selectedLandRegisters.length; i++) {
                            const item = selectedLandRegisters[i];
                            setStatus({
                                project_id: props.project ? props.project.id : '',
                                status: status_id,
                                status_type: type,
                                grundbuch_id: item.grundbuch_id
                            });
                        }
                        break;
                }
            }
        });
    };

    // const onClickEditSelectionPersons = (e: any) => {
    //
    // }

    const onClickDeleteSelectionLandRegisters = (e: any) => {
        CustomConfirmDialog({
            message: t('globalData:dialogs.deleteLandRegisterDialog.' + (selectedLandRegisters.length > 1 ? 'plural' : 'singular')),
            header: t('confirmDialog:deleteDialogHeader'),
            translation: t,
            onConfirm: () => {
                for (let i = 0; i < selectedLandRegisters.length; i++) {
                    const item = selectedLandRegisters[i];
                    deleteLandRegister({
                        project_id: props.project ? props.project.id : '',
                        grundbuch_id: item.grundbuch_id,
                        common_data: true
                    });
                }
            }
        });
    };

    const onClickDeleteImport = (e: any) => {
        CustomConfirmDialog({
            message: t('globalData:dialogs.deleteImport'),
            header: t('confirmDialog:deleteDialogHeader'),
            translation: t,
            onConfirm: () => {
                deleteImportData();
                hideDialog();
            }
        });
    };

    const hideDialog = () => {
        setShowCSVImportDialog(false);
        setShowCSVImportData(false);
    };

    const getOwnImportedData = () => {
        return user && person.data.benutzer_id === user.id;
    };

    const submitImport = () => {
        CustomConfirmDialog({
            message: t('globalData:dialogs.finishImport.message'),
            header: t('globalData:dialogs.finishImport.header'),
            translation: t,
            onConfirm: () => {
                setSkipImport(false);
            }
        });
    };

    const getImportedDataDialogContent = () => {
        if (getOwnImportedData()) {
            return (<PersonOverview projectId={projectId}
                                    showParcels={true}
                                    showPersons={false}
                                    showLandRegisters={true}
                                    showSuggestions={true}
                                    showShareInfos={false}
                                    editable={true} expandable={true}
                                    hideGlobalFilter={true} commonData={false}
                                    showColumnFilters={false}
                                    geoData={geoDataProject}
            />);
        } else {
            return (<div>
                <p>{t('globalData:global.importedDataDialog.notYourData')}</p>
                <p>{person.data.benutzer_name}</p>
                <p>{new Date(person.data.zeitstempel).toLocaleString()}</p></div>);
        }
    };

    return (
        <>
            {/* 0: Users, 3: Admins*/}
            <LayoutMainContentTabMenu project={props.project} items={menuItems} activeIndex={activeIndex}
                                      showMap={showMap}
                                      onTabChange={() => {
                                          setViewButtonsRerender(!viewButtonsRerender);
                                      }}/>

            {/** All usable dialogs in this view **/}
            {showCSVImportDialog && <CustomDialog
                className={'p-1'}
                style={{maxWidth: '100%'}}
                formName={formName}
                header={t('globalData:global.getCSVDialog.headerImportPersons')}
                headerType={CustomDialogHeaderType.Import}
                showFooter={true}
                visible={showCSVImportDialog}
                onCancel={hideDialog}
                onHide={hideDialog}>
                <ImportCsvAlkis id={formName} projectId={props.project ? props.project.id : null}
                                onSubmit={hideDialog}/>
            </CustomDialog>}
            {showCSVImportData && <CustomDialog
                className={'imported-data p-1'}
                style={{minWidth: '100%', minHeight: '100%'}}
                header={t('globalData:global.getCSVDialog.headerImportedData') + ' ' + t('common:from') + ' ' + new Date(person.data.zeitstempel).toLocaleString()}
                headerType={CustomDialogHeaderType.Import}
                showFooter={getOwnImportedData()}
                visible={showCSVImportData}
                onCancel={hideDialog}
                onClick={submitImport}
                onHide={hideDialog}
                maximized={true}
                customButtons={[<Button
                    type="button"
                    label={t('globalData:buttons.deleteImport')}
                    icon="pi pi-trash"
                    className="p-button-text"
                    onClick={onClickDeleteImport}
                />]}
                customButtonsBefore={true}
            >
                {getImportedDataDialogContent()}
            </CustomDialog>}
        </>
    );
};

export default GlobalData;
